







import { Component, Vue, Prop } from 'vue-property-decorator';

// 声明组件*****************
@Component({
  components: {
      
  }
})
export default class CreateInfo extends Vue {
  // 属性*****************
  // private type: string = 'loading';

  // props
  @Prop({ default:()=>({}) }, Object) 
  private data!: object

  // 方法*****************

}
